import { render, staticRenderFns } from "./location-page.vue?vue&type=template&id=7ed513fe&scoped=true"
import script from "./location-page.vue?vue&type=script&lang=js"
export * from "./location-page.vue?vue&type=script&lang=js"
import style0 from "./location-page.vue?vue&type=style&index=0&id=7ed513fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed513fe",
  null
  
)

export default component.exports